import * as S from './About.style';
import * as T from './About.types';
import { Attributes } from './attributes';

export const About: React.FC<T.AboutCollection> = ({ items, subtitle, title }) => {
  return (
    <S.Atributos className="section">
      <S.Container>
        <h3>{title}</h3>
        <p>{subtitle}</p>

        <Attributes items={items} />
      </S.Container>
    </S.Atributos>
  );
};
